<template>
  <nav class="nav">
    <div class="nav__logo" @click="goToHome">
      <img class="logo-icon" src="@/assets/img/nav/logo.svg" alt="logo" />
    </div>
    <div class="nav__items" :class="isShowMenu && 'show'">
      <div class="languages">
        <div class="languages-lang">
          <a
            :class="['lang', activeLang === 'ja-JP' && 'activeLang']"
            @click="changeLangs('ja-JP')"
            >JA</a
          >
          <div class="stick"></div>
          <a
            :class="['lang', activeLang === 'en-US' && 'activeLang']"
            @click="changeLangs('en-US')"
            >EN</a
          >
        </div>
        <Button
          :title="t('top.contact')"
          :onClick="goToContact"
          :class="[activeLang === 'ja-JP' && 'ja']"
        />
      </div>
      <div class="list-item">
        <div
          v-for="item in nav"
          :key="item.name"
          :class="['item', activeLang === 'ja-JP' && 'active-lang nav-item']"
          @click="gotoTopTag(item.name)"
        >
          {{ $t(item.text) }}
        </div>
      </div>
    </div>
    <div class="nav__hambugers" @click="isShowMenu = !isShowMenu">
      <div class="hambugers">
        <img
          class="menu"
          src="@/assets/menu-sp.svg"
          v-if="!isShowMenu"
          :class="isShowMenu && 'show'"
        />
        <img src="@/assets/close-sp.svg" v-else class="close" />
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useNavigate } from '@/composable';
import Button from '@/components/Button/index.vue';

interface NavItem {
  name: string;
  text: string;
  active: boolean;
}

export default defineComponent({
  name: 'NavBar',
  props: {},
  components: { Button },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { navigate } = useNavigate();
    const { t, locale } = useI18n();
    const activeLang = ref(localStorage.getItem('locale') || 'en-US');
    const isMobile: any = inject('isMobile');
    const nav = reactive<NavItem[]>([
      {
        name: 'about-us',
        text: 'top.nav-1',
        active: false
      },
      {
        name: 'services',
        text: 'top.nav-2',
        active: false
      },
      {
        name: 'industries',
        text: 'top.nav-3',
        active: false
      },
      // {
      //   name: 'news',
      //   text: 'top.nav-4',
      //   active: false
      // },
      // {
      //   name: 'menber',
      //   text: 'top.nav-5',
      //   active: false
      // },
      {
        name: 'company-information',
        text: 'top.nav-6',
        active: false
      }
      // {
      //   name: 'recruit',
      //   text: 'top.nav-7',
      //   active: false
      // }
    ]);
    const isShowMenu = ref(false);

    const goToHome = () => {
      isShowMenu.value = false;
      navigate('/top');
    };

    const goToContact = () => {
      isShowMenu.value = false;
      navigate('/contact');
    };

    const changeLangs = (val: string) => {
      locale.value = val;
      localStorage.setItem('locale', val);
      activeLang.value = val;
      isShowMenu.value = false;
    };

    const gotoTopTag = (val: string) => {
      isShowMenu.value = false;
      if (route.name === 'Contact') {
        navigate('/top', 'router', { tag: val });
      } else {
        router.push({
          name: route!.name || '',
          query: { tag: val }
        });
      }
    };

    return {
      nav,
      isShowMenu,
      navigate,
      goToHome,
      t,
      goToContact,
      changeLangs,
      activeLang,
      gotoTopTag,
      isMobile
    };
  }
});
</script>

<style scoped lang="scss">
.ja {
  ::v-deep(.button-item--top) {
    .button-item--top__title {
      font-size: 1.5rem;
      padding-right: 1.5rem;
      flex-shrink: 0;
      font-family: 'Tayori-Roboto' !important;
      letter-spacing: 0.8px;
    }
  }
}
.nav-item {
  font-size: 1.5rem !important;
}
.active-lang {
  font-family: 'Tayori Noto Sans JP' !important;
}

.nav-item.active-lang {
  @include breakpoint-down(slg) {
    font-size: 2rem !important;
  }
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: $heighNavbar;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f5f5f5;
  overflow: hidden;
  box-shadow: 0rem 0.2rem 1.5rem rgba(0, 0, 0, 0.05);
  @include breakpoint-down(slg) {
    height: $heighNavbarMobile;
  }
  &__logo {
    padding: 3.5rem 3.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover,
    &:focus {
      opacity: 0.6;
    }
    @include breakpoint-down(slg) {
      padding: 1.6rem 2rem;
      .logo-icon {
        width: 15.3rem;
        height: 3.9rem;
      }
    }
  }
  &__items {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    padding-right: 3.2rem;
    .languages {
      display: flex;
      align-items: center;
      padding-bottom: 1.8rem;
      flex-shrink: 0;
      .languages-lang {
        display: flex;
        align-items: baseline;
        justify-content: center;
        padding-right: 4rem;
        .activeLang {
          font-weight: 500 !important;
          text-decoration-line: unset !important;
        }
        .lang {
          font-family: 'Tayori-Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 1.4rem;
          line-height: 1.8rem;
          text-decoration-line: underline;
          color: #3a3a3a;
        }
        .stick {
          width: 0.1rem;
          height: 1.1rem;
          background: #d1d1d1;
          margin: 0 0.8rem;
        }
        @include breakpoint-down(slg) {
          .lang {
            font-size: 1.6rem;
          }
        }
      }
      ::v-deep(.button-item) {
        .button-item--top {
          @include breakpoint-up(slg) {
            width: 16rem;
          }
        }
        &.ja {
          .button-item--top {
            @include breakpoint-up(slg) {
              width: 18.4rem;
              padding: 1rem 3.1rem;
              padding-left: 3.9rem;
            }
          }
        }
        &:hover,
        &:focus {
          opacity: 0.9;
          box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.25);
        }
        @include breakpoint-down(slg) {
          .active-lang {
            font-size: 2rem !important;
            letter-spacing: 0.08rem;
          }
        }
      }
    }
    .list-item {
      display: flex;
      flex: 1;
      @include breakpoint-down(slg) {
        justify-content: center;
        margin: auto;
      }
      @include breakpoint-down(xs) {
        width: 75%;
      }
      .item {
        margin-right: 2.4rem;
        cursor: pointer;
        font-family: 'Tayori-Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: #3a3a3a;
        white-space: nowrap;
        &:last-child {
          margin-right: unset;
        }
        &:hover,
        &.active {
          opacity: 0.6;
        }
      }
    }
    @include breakpoint-down(slg) {
      position: fixed;
      top: 0;
      left: auto;
      right: 0;
      bottom: 0;
      z-index: 10;
      flex-direction: column-reverse;
      background: #000;
      width: 100%;
      transition: 0.2s;
      transform: translateX(100%);
      padding: 0;
      align-items: flex-start;
      overflow: auto;
      display: none;
      .languages {
        flex-direction: column-reverse;
        width: 100%;
        padding-bottom: 6rem;
        .languages-lang {
          padding-right: unset;
          .lang {
            color: #ffffff;
          }
        }
        ::v-deep(.button-item) {
          box-shadow: 0rem 0rem 2.4rem rgba(0, 0, 0, 0.15);
          border-radius: 0.8rem;
          height: 6.4rem;
          width: 295px;
          margin-bottom: 4.4rem;
          .button-item--top {
            padding: 2rem 2.4rem;

            &__title {
              font-size: 2.4rem;
            }
          }
        }
      }
      .list-item {
        flex-direction: column;
        padding-top: 8rem;
        // padding-left: 6.4rem;
        .item {
          font-weight: 600;
          font-size: 2.4rem;
          line-height: 2.4rem;
          letter-spacing: 0.8px;
          color: #ffffff;
          margin-right: unset;
          padding-bottom: 3.2rem;
        }
      }
    }

    &.show {
      animation: fade-in 0.4s forwards ease-in-out;
      display: flex;
      position: fixed;
      height: 100vh;
      overflow-y: auto;
    }
  }
  &__hambugers {
    @include breakpoint-up(slg) {
      display: none;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

    .hambugers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.6rem 2rem;
      .menu {
        max-width: 100%;
      }
      .close {
        max-width: 100%;
        z-index: 11;
      }
    }
    .text {
      font-family: 'Outfit';
      color: $white;
      font-style: normal;
      font-weight: 500;
      font-size: 1.6rem;
      text-align: center;
      margin-top: 0.164rem;

      @include breakpoint-down(slg) {
        font-size: 1.2rem;
      }
    }
  }
}

// animate
@keyframes slide-right {
  from {
    transform: translateX(100%);
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0%);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(0%);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0%);
  }
}
</style>
